import { render } from "./payroll-items.vue?vue&type=template&id=55937284"
import script from "./payroll-items.vue?vue&type=script&lang=js"
export * from "./payroll-items.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__